<div class="partial-success-status-wrapper">
    <div
        class="progress-bar"
        appTooltip
        trigger="hover"
        [component]="tooltipComponent"
        [componentData]="data"
        position="bottom"
        [showDelay]="200"
        [hideDelay]="200"
    >
        <!-- Background text (dark on light background) -->
        <span class="background-text">
            <ng-container *ngTemplateOutlet="percentageText"></ng-container>
        </span>

        <!-- Colored segments container with overflow hidden - ONLY covers green success area -->
        <div class="colored-segments-container" [style.width.%]="normalizedSuccessPercentage()">
            <!-- Foreground text (light on colored background) -->
            <div class="foreground-text">
                <ng-container *ngTemplateOutlet="percentageText"></ng-container>
            </div>
        </div>

        <div class="progress-segments">
            <div class="segment success" [ngStyle]="{ 'flex-grow': normalizedSuccessPercentage() }"></div>
            <div class="segment partial-success" [ngStyle]="{ 'flex-grow': normalizedPartialSuccessPercentage() }"></div>
            <div
                class="segment failure"
                [ngStyle]="{ 'flex-grow': normalizedFailurePercentage() }"
                [class.hidden]="normalizedFailurePercentage() === 0"
            ></div>
        </div>
    </div>
</div>

<ng-template #percentageText>
    @if (adjustedPartialSuccessPercentage() > 0) {
        {{ adjustedSuccessPercentage() }}% / {{ adjustedPartialSuccessPercentage() }}%
    } @else {
        {{ adjustedSuccessPercentage() }}%
    }
</ng-template>
